import {routeCodes} from "@constants/routes";
import {Filtro, PoderesEsferasOptions} from "@types";
import React from "react";
import {Button, ButtonGroup, ToggleButton} from "react-bootstrap";
import {Search} from "react-feather";
import "./FiltroSearch.scss";

export interface FiltroSearchProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  poderesOptions: PoderesEsferasOptions[];
  esferasOptions: PoderesEsferasOptions[];
  esferaCheckedState: boolean[];
  updateEsferaCheckedState: (pos: number) => void;
  handleApplyFilter: () => void;
  handleEnterKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  setSearchString: (value: string) => void;
  poderCheckedState: boolean[];
  updatePoderCheckedState: (value: number) => void;
  handleGetChips: () => JSX.Element;
  searchString: string;
  verifyEsferaCheckedState: () => boolean;
  verifyPoderCheckedState: () => boolean;
}

export const FiltroSearch = ({
  poderesOptions,
  setShowModal,
  showModal,
  esferaCheckedState,
  esferasOptions,
  updateEsferaCheckedState,
  handleApplyFilter,
  handleEnterKeyPress,
  poderCheckedState,
  updatePoderCheckedState,
  handleGetChips,
  setSearchString,
  searchString,
  verifyEsferaCheckedState,
  verifyPoderCheckedState,
}: FiltroSearchProps) => {
  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      <div className="termos-search-container">
        <div
          className={`dropdown-menu-container ${
            window.location.pathname === routeCodes.ALERTAS_RESULTADOS
              ? "dropdown-cadastrar-alerta"
              : "dropdown-buscar-termos"
          }`}
        >
          <div
            className="mobile-dropdown-button-container"
            onClick={() => setShowModal(!showModal)}
          >
            {showModal ? (
              <span className="filtro-button">Filtro &#9650;</span>
            ) : (
              <span className="filtro-button">Filtro &#9660;</span>
            )}
          </div>
        </div>

        {/* {true ? <div className="dropdown-menu">teste</div> : null} */}
        <div className="mobile-item-center">
          <div className="item-center-input">
            <input
              type="text"
              placeholder="Buscar Diário Oficial"
              onKeyUp={handleEnterKeyPress}
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
            />

            <Search style={{position: "absolute", right: 10, top: 6, color: "#c2c1c1"}} />
          </div>

          <div className="termos-filtro-chips">{handleGetChips()}</div>

          {showModal ? (
            <div className="navegacao-dropdown-menu">
              <div className="poderes-item filtro-item">
                <h6>Poder</h6>
                <ButtonGroup className="mb-2">
                  {poderesOptions.map((p, i) => {
                    return (
                      <ToggleButton
                        key={p.label}
                        id={`poderesRad-${p.key}`}
                        type="checkbox"
                        name={p.key}
                        variant="outline-secondary"
                        value={""}
                        checked={poderCheckedState[i]}
                        onChange={(e) => updatePoderCheckedState(i)}
                      >
                        {p.label}
                      </ToggleButton>
                    );
                  })}
                </ButtonGroup>
              </div>
              <div className="esferas-item filtro-item">
                <h6>Esferas</h6>
                <ButtonGroup className="mb-2">
                  {esferasOptions.map((p, i) => {
                    return (
                      <ToggleButton
                        key={p.label}
                        id={`esferasRad-${p.key}`}
                        type="checkbox"
                        name={p.key}
                        variant="outline-secondary"
                        checked={esferaCheckedState[i]}
                        onChange={() => {
                          updateEsferaCheckedState(i);
                        }}
                        value={""}
                      >
                        {p.label}
                      </ToggleButton>
                    );
                  })}
                </ButtonGroup>
              </div>
              <div className="apply-filter-button">
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowModal(!showModal)}
                >
                  Cancelar
                </Button>
                <Button
                  className="apply-filter-button-box"
                  variant="primary"
                  onClick={() => {
                    handleApplyFilter();
                    setShowModal(!showModal);
                  }}
                  disabled={
                    verifyEsferaCheckedState() === true ||
                    verifyPoderCheckedState() === true
                      ? true
                      : false
                  }
                >
                  Aplicar
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
